// extracted by mini-css-extract-plugin
module.exports = {"donutChart":"TopCampaignsRateReport_donutChart__1CaeO"};